import { createEnum } from '../helpers'

/**
 * Per-row error types for the Dun & Bradstreet number import (Customer ERP + D&B number).
 * `missingCustomerErp` when the Customer ERP column is blank after cleaning; `invalidDunsNumber`
 * when the D&B value is not exactly 9 digits after stripping dashes.
 */
export const DNB_IMPORT_ERRORS = ['missingCustomerErp', 'invalidDunsNumber'] as const
export const DNB_IMPORT_ERROR_TYPES = createEnum(DNB_IMPORT_ERRORS)
export type DnbImportErrorType = (typeof DNB_IMPORT_ERRORS)[number]
